import Package from "../models/Package";
import t from "../locales/translation";
import { useEffect, useState } from "react";
import PackageGridItem from "./PackageGridItem";
import { PackageBenefitsProps } from "../models/PropsInterface";
import "../cssStyles/PackageBenefits.css";
import { deepLinkHandlerMYOS } from "../helpers/commonFunctions";

const PackageBenefits = (props: PackageBenefitsProps) => {
  /*-----------------------------
   *          STATE
   * ----------------------------*/
  const [packageBenefits, setPackageBenefits] = useState<Package>();

  useEffect(() => {
    if (props.packages && Object.keys(props.packages).length > 0) {
      setPackageBenefits(
        props.packages.find((pkg) => {
          return pkg.productSettingId === props.selectedId;
        }) ?? props.packages[0]
      );
    }
  }, [props.selectedId]);

  return (
    packageBenefits && (
      <div className={`vas-col-12`}>
        <div className={`vas-row vas-justify-content-center`}>
          {packageBenefits?.benefits.rows.length > 0 && (
            <div className={`vas-col-12`}>
              <p
                className={`vas package_benefits__greyed_text vas-mb-0`}
                style={{ fontSize: "15px" }}
              >
                {t.benefits}
              </p>
              <div className={`package_benefits__line_style`} />
            </div>
          )}
          <div className="vas-col-12">
            {packageBenefits?.benefits?.rows.map((item) => {
              return (
                <PackageGridItem
                  title={item.title}
                  desc={item.description}
                  pillText={item.value ?? ""}
                ></PackageGridItem>
              );
            })}
          </div>
          {props.packages?.findIndex(
            (e) =>
              e?.service.toLowerCase() === "turbo" ||
              e?.service.toLowerCase() === "premium" ||
              e?.service.toLowerCase() === "bumpup"
          ) != -1 && (
            <div className={`vas-col-12`}>
              <p
                className={`vas vas-m-0 package_benefits__font_size_sm package_benefits__greyed_text`}
              >
                * {t.numberOfViews}
              </p>
              <p
                className={`vas vas-m-0 vas-mt-1 package_benefits__font_size_sm package_benefits__greyed_text`}
              >
                * {t.byPurchasingThe}
                <a
                  target={"_top"}
                  href={`https://jo.opensooq.com/${props.language}/termOfUse`}
                  className={`vas vas-p-1 package_benefits__less_greyed_text`}
                >
                  {" "}
                  {t.termsOfUse}
                </a>{" "}
                &
                <a
                  target={"_top"}
                  href={`https://jo.opensooq.com/${props.language}/site/page?view=privacyPolicy`}
                  className={`vas vas-p-1 package_benefits__less_greyed_text`}
                >
                  {" "}
                  {t.privacyPolicy}
                </a>
              </p>
            </div>
          )}

          <div className={"vas-col-12"}>
            <p className={`vas vas-mt-3 package_benefits__font_size_sm`}>
              {" "}
              {t.doYouNeedHelp}{" "}
              <p
                onClick={() => deepLinkHandlerMYOS('xx/help')}
                className={`vas package_benefits__hyperlink vas-text-primary pointerCursor`}
              >
                {t.contactUs}{" "}
              </p>
            </p>
          </div>
        </div>
      </div>
    )
  );
};

export default PackageBenefits;
